import * as React from "react";
import {MouseEvent} from "react";
import * as FormGroup from "react-bootstrap/lib/FormGroup";
import {FilterOption} from "./FilterOption";
import {IOption} from "../../types";
import {FieldFacet} from "../../types";

// tslint:disable-next-line:interface-name
interface OptionListProps {
    name: string,
    id: string,
    options: IOption[],
    selected: string[],
    facet: FieldFacet,
    disableFacet?: boolean,
    collapsed?: boolean,
    onChange?: (values: IOption[]) => void
}

// tslint:disable-next-line:interface-name
interface OptionListState {
    collapsed: boolean
}

export class OptionList extends React.Component<OptionListProps, OptionListState> {

    constructor(props: OptionListProps) {
        super(props);
        this.state = {
            collapsed: props.collapsed || false
        };
        this.onChangeOption = this.onChangeOption.bind(this);
        this.onClickCollapse = this.onClickCollapse.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
    }


    public render() {
        return <FormGroup key={`filter-${this.props.id}`}>
            <div className="form-item">
                <label className="label">
                    <a href="#" onClick={this.onClickCollapse}>{this.props.name} {this.renderExpandIndicator()}</a>
                </label>
                {this.renderOptions()}
            </div>
        </FormGroup>;
    }
    private renderExpandIndicator() {
        return <span className="pull-right expand-icon">{this.state.collapsed ?
            <i className="fa fa-angle-down"/> : <i className="fa fa-angle-up"/>}</span>;
    }

    private renderOptions() {
        let options = this.props.options;
        if (this.state.collapsed) {
            options = options.filter(o => this.props.selected.indexOf(o.key) !== -1);
        }
        let filters = options.map(o => {
            const key = o.key.toLowerCase();
            const selected = this.props.selected.indexOf(o.key) !== -1;
            return <FilterOption
                id={o.key}
                name={o.name}
                key={o.key}
                selected={selected}
                disableFacet={this.props.disableFacet}
                disabled={!this.props.disableFacet && this.props.facet[key] === 0 && !selected}
                resultCount={this.props.facet[key] || 0}
                onChange={this.onChangeOption.bind(this, o.key)}
            />
        });
        if (this.state.collapsed) {
            filters = filters.concat(<small key="more" onClick={this.onClickCollapse}>Alle filters weergeven</small>);
        }
        return filters
    }

    private onChangeOption(key: string, e: IOption | undefined) {
        if (!this.props.onChange) {
            return;
        }
        const selected: IOption[] = this.props.options.filter(o => this.props.selected.indexOf(o.key) !== -1);
        if (e) {
            if (this.props.selected.length === 0) {
                this.props.onChange([e]);
            }
            if (this.props.selected.indexOf(e.key) === -1) {
                this.props.onChange([...selected, e]);
            } else {
                this.props.onChange([...selected.filter(o => o.key !== e.key), e]);
            }
        } else {
            this.props.onChange(selected.filter(o => o.key !== key) || [])
        }
    }

    private onClickCollapse(e: MouseEvent<HTMLAnchorElement>) {
        this.setState({
            collapsed: !this.state.collapsed
        });
        e.preventDefault();
    }
}


// WEBPACK FOOTER //
// ./src/homepage/components/filters/OptionList.tsx